<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <!--                <base-input v-model="username" alternative-->
                <!--                            class="mb-3"-->
                <!--                            v-mask="'#######-#'"-->
                <!--                            placeholder="Número de inscrição"-->
                <!--                            addon-left-icon="ni ni-single-02">-->
                <!--                </base-input>-->
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '1234567-8',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {
        "num_cand": "U2FsdGVkX19eQ1uKf2OSqLNAvzyoF3IoYpUBW3XIJ9Q=",
        "cpf": "U2FsdGVkX1/I4NqBQdEhgbPR4PuNwUC8EVqBj+LkJB4="
      }, {
        "num_cand": "U2FsdGVkX19hAkhlJRitHr57TIO3zqNWAqKL+xi/H4I=",
        "cpf": "U2FsdGVkX18hhBMWbXBtUKzvwO1q3Aqezjk9ezk/g80="
      }, {
        "num_cand": "U2FsdGVkX19MKu2y6kH0u/DnsUS1ks3zNaiZSYBVYIE=",
        "cpf": "U2FsdGVkX1/vj/KMS97y1YN7NwaeQPMLxon/KBWXZrc="
      }, {
        "num_cand": "U2FsdGVkX197XWNriBNqoILRZgKn1f5MiAaMBolpzPQ=",
        "cpf": "U2FsdGVkX1+/vVzyt1FVmINqQBGpTIdGi9RxRax3k1E="
      }, {
        "num_cand": "U2FsdGVkX18IzquT3ezrJ5lfXnFfSXXYMFAlQPWYlVE=",
        "cpf": "U2FsdGVkX1+A80s9TjJ6JEFn/uGLD9kpwm4DvPo1a0Y="
      }, {
        "num_cand": "U2FsdGVkX19ZsfeyqybpsyoakA+U5dP+AoPknmKpbdU=",
        "cpf": "U2FsdGVkX1/0y0FxCZJE/jcs9qDZSgZGNdW8dqNi+l4="
      }, {
        "num_cand": "U2FsdGVkX1/PpNsoyHFU+MIn/mfTOWnMSa3i4hEAEss=",
        "cpf": "U2FsdGVkX19ZZYJ2SaX7q/h5arMBkl7cAFw4/SXgO1k="
      }, {
        "num_cand": "U2FsdGVkX1/aLy6RkP8HqmXYwGdUcTkwEyN8vnZNxA4=",
        "cpf": "U2FsdGVkX1+z7WDHk7w/ccGp1zoAO2oyZ4DWCOdLRww="
      }, {
        "num_cand": "U2FsdGVkX18asX+xveM8P3FIHG9lCZS4HYRLKlzNME8=",
        "cpf": "U2FsdGVkX19No8/0oS35CqsPs/7UpjMFbWD0sJIGDmc="
      }, {
        "num_cand": "U2FsdGVkX18AyKKMhLs0nBk6Hjuol7Ph/l8owzLt/qE=",
        "cpf": "U2FsdGVkX1+TiDJBijCbiZpZPN+1RxJNyqvdIGTJ86Q="
      }, {
        "num_cand": "U2FsdGVkX1+EeAb6omeOuJZpaxCoY6MWFFXr1Pa9J4U=",
        "cpf": "U2FsdGVkX198graatuR4Oa8fOe3NHPGQR+Mhp/eM8Cw="
      }, {
        "num_cand": "U2FsdGVkX18KGJ74tw3yOdYRMN2IRU2x52B3O/p+YUA=",
        "cpf": "U2FsdGVkX1/mlCEG/GUHG/5l6VR/0PTX8dtmLVCkVLI="
      }, {
        "num_cand": "U2FsdGVkX19zKpTSuh1jImqcr1oQFzDt79bb1HH/sKw=",
        "cpf": "U2FsdGVkX19B8CO1EQ6pHOvcfrLzkVLcu593mctQaag="
      }, {
        "num_cand": "U2FsdGVkX1+5v9YprWElncf9PWzHVRWeNUiEgQDQL+0=",
        "cpf": "U2FsdGVkX1+taV8QZdsXaB7qw0WBDl0q02Roj8QwgFY="
      }, {
        "num_cand": "U2FsdGVkX1+AK6p3zTpEjKvr50MWdM+YareCZQCGGok=",
        "cpf": "U2FsdGVkX19Xgex9pzEXnlc+AKLfCHYkLfNmqpzTPNc="
      }, {
        "num_cand": "U2FsdGVkX1+Tb+zHENd99do0ka5GGX0meoJThxJh0ZI=",
        "cpf": "U2FsdGVkX194p6bPZEYID32JtvFZjoz/0bPhfvApvC4="
      }, {
        "num_cand": "U2FsdGVkX1/k7iMj0kYQhdo7Xh91YUxcmCmiTNg+xEo=",
        "cpf": "U2FsdGVkX1/1Bz+dEukzP5a+DnwFYlnZXDYl5QGj9pM="
      }, {
        "num_cand": "U2FsdGVkX1/O/Tt7eb7a2h5Tc+hOumh6LApxenZgVc8=",
        "cpf": "U2FsdGVkX19GiHJSEPbuQWoiDJWJDrlwL0C45/rDDxw="
      }, {
        "num_cand": "U2FsdGVkX1/syUNVMUs15HhFQ0IX1H5KxaIdkDdcheM=",
        "cpf": "U2FsdGVkX18FTt3aHz6uxXxei72hVD3cjWRk8dIm4VE="
      }, {
        "num_cand": "U2FsdGVkX19eB9+hIfvSC7WthpJo3YQBkAwtFjO+FMc=",
        "cpf": "U2FsdGVkX18Rb8Oae+WXQmHXXCCBg5VSaNvbseAWAok="
      }, {
        "num_cand": "U2FsdGVkX1+j+jntvv1RcYyEWmlQ3kIVsj93GLVCUa0=",
        "cpf": "U2FsdGVkX1/vdJxCLq+lEnwkzKVfDqvxSRR8qms5C48="
      }, {
        "num_cand": "U2FsdGVkX1+1B0s9jAgxll+ECCNv0Cw0RQWGdxogRNw=",
        "cpf": "U2FsdGVkX18DfikrHPAwj6urI1JZSEUgsKL1wRLBEYg="
      }, {
        "num_cand": "U2FsdGVkX1/20lKP4QupHksixfGWGF7GW7HE5WBynJ8=",
        "cpf": "U2FsdGVkX18CMw+MypPXsQI/AL1TgUEom5hQwc8ejbk="
      }, {
        "num_cand": "U2FsdGVkX18UykCSwvK1MUSdLl0NC0To0/oMpfLzhAY=",
        "cpf": "U2FsdGVkX1+6M6vaA+OFW5dmZo10bZ5vpy1rH4Hd9jA="
      }, {
        "num_cand": "U2FsdGVkX187frSEdJM1g565e3IWXvrOnDTA8S2r66w=",
        "cpf": "U2FsdGVkX189t2oIxuErsuQfoBu9J3ecGbC9hdFyuAE="
      }, {
        "num_cand": "U2FsdGVkX18xlVl5p3L6n+qUfPvo4GbCxVHQ2ejckSg=",
        "cpf": "U2FsdGVkX19H+4eqKkgh2d8a0vUhgY7N52hx3eookPg="
      }, {
        "num_cand": "U2FsdGVkX1/sLyhU4lCEktvPWBVMDUoSdavU70elkek=",
        "cpf": "U2FsdGVkX19GtcnSuLvqStC5yHQ5v8tTWY6JXrqqKS0="
      }, {
        "num_cand": "U2FsdGVkX1+vfyIt69V/dIr0G8buX68kjfm+KxC2kdc=",
        "cpf": "U2FsdGVkX1+kIb4ASrvEy3gPD0dbTNqEAn/mb7UPRwY="
      }, {
        "num_cand": "U2FsdGVkX1+ViBl3GD13O33eyYHf+Uyz7//K6lZfXw4=",
        "cpf": "U2FsdGVkX19mF8SaELtapIa/u2uhALRFO2YNEYcpB/k="
      }, {
        "num_cand": "U2FsdGVkX18qP8xYfEdDfda8P2s9MPGr/bAnwZqswqg=",
        "cpf": "U2FsdGVkX19QpqZhgQtSIou7ejLvH+mNKCUti8tP+Mk="
      }, {
        "num_cand": "U2FsdGVkX1/TAwWU4/yBw6OAMrvzlt2i7dOlzUuux0U=",
        "cpf": "U2FsdGVkX1+dGK5DSJIZqfIosFu8LtLy+28wZQU1HH0="
      }, {
        "num_cand": "U2FsdGVkX18t1yiBo7BHiaYcScSnWV0YQ67mJNRoGPc=",
        "cpf": "U2FsdGVkX182fmOhkv9oWStUoVcdZxbbMYxuXl4DHh8="
      }, {
        "num_cand": "U2FsdGVkX1/yhMBhaxMnZSberKTGJpL1Jce79Fo8uV8=",
        "cpf": "U2FsdGVkX19TIW1mqlzUuFs4FeAjbtiZAc15vHiolNo="
      }, {
        "num_cand": "U2FsdGVkX1/AGG3L+aySp3BWpkcF72i6+iBd9iRG6yo=",
        "cpf": "U2FsdGVkX1+WPLJ8L4QccIp04cN7aGqvxPxtcWAwu/E="
      }, {
        "num_cand": "U2FsdGVkX182Vkt+cc/2QHkUXjH37chlpPg5azSjDhc=",
        "cpf": "U2FsdGVkX19oyiCVqbO2mBTIpF/oZ7fIT5XvSnVv40I="
      }, {
        "num_cand": "U2FsdGVkX18ecyhI6N2NQvDdWxp7/ZD5HgUo4gudRFM=",
        "cpf": "U2FsdGVkX1+uf9jwuG5peU+ThBJxMNQYQNEzyX1lN+c="
      }, {
        "num_cand": "U2FsdGVkX18UqNqqmQq/9NOfX/TvNL4WME7eqimZhx4=",
        "cpf": "U2FsdGVkX1+6jjjdqFEBY2lUSgojETVEIUhYI6qCQUY="
      }, {
        "num_cand": "U2FsdGVkX18AzMGeeoUKRrC+gkEwRupxWA+7ICAHU/g=",
        "cpf": "U2FsdGVkX1+1b0VIBKdsQqRhzqeI3ClVnOSnwsGCaWQ="
      }, {
        "num_cand": "U2FsdGVkX1+rXCthOxXql9L09ZcGQP6oCVjKr9On6xI=",
        "cpf": "U2FsdGVkX18xvI0shvIb5RquGyUiFZqvDi67uPCz10Q="
      }, {
        "num_cand": "U2FsdGVkX1+mronZ/dY67U0CS0CS5ZRxmtEW7Osmo40=",
        "cpf": "U2FsdGVkX1/OKOUg2iO6NlZCGdN6EuF8S7y8v6I+dmc="
      }, {
        "num_cand": "U2FsdGVkX195G5WoGmF/d05yki/vocLtEdnu1pRqLbM=",
        "cpf": "U2FsdGVkX19/h79l2XM7uGlb03OZXTRaR5ftuIFaMAw="
      }, {
        "num_cand": "U2FsdGVkX1/alTo+sjxW4BflDWdSCFtIGEmQKNjf4wo=",
        "cpf": "U2FsdGVkX1+TLzkCayyLyHJosK9Zway3perEfSCAR3o="
      }, {
        "num_cand": "U2FsdGVkX1+87lLxY0cDmcRdZZ542TyiB2sLjDjcD/E=",
        "cpf": "U2FsdGVkX19Z/oNmKyjPENtD7Nr2MSjSflbA1qaAflU="
      }, {
        "num_cand": "U2FsdGVkX1/69x7nLCaj3u8wVP0j+EoYne/ffuR54+s=",
        "cpf": "U2FsdGVkX19oPKzgEHzm+rBSIyFyzkPv9U191WlX0mo="
      }, {
        "num_cand": "U2FsdGVkX19mirqlpGFQm+BUiyXmHA5y7iqUbVDB+fM=",
        "cpf": "U2FsdGVkX1907T/2BwT4eQpeq8DoZvqwzQEVWUxb5Dw="
      }, {
        "num_cand": "U2FsdGVkX19hSdB0POhQh7wwntpJ+gg1hAamTPVfXs8=",
        "cpf": "U2FsdGVkX19Y9Xdb5jMO2rZm3oGVbbDGHLZVRhZEDJ8="
      }, {
        "num_cand": "U2FsdGVkX1+q8cRNi4rZNB6eOHqghUE3mVbE+T4NbO8=",
        "cpf": "U2FsdGVkX1+L+8tyu2BxcL3KZlZXAGuZ+0K7B8cPvkw="
      }, {
        "num_cand": "U2FsdGVkX19726iiUoh7Ps9JrbS6+N5A8OFTTxB5tQs=",
        "cpf": "U2FsdGVkX1+MMmgsT3P/f+pWMCHRKcnRKLt4lZbZxaU="
      }, {
        "num_cand": "U2FsdGVkX1/i4o86L+5SBHEaR3BzFXnzjHM1lMFYqF8=",
        "cpf": "U2FsdGVkX1/PCqftLUSloJ2yzj1bF5uHXjfC0enPoUs="
      }, {
        "num_cand": "U2FsdGVkX19LjUCaEx7carpm2hiYLpFyJ144F/IMK7o=",
        "cpf": "U2FsdGVkX196E8f9sbp8g0LkpXSXIeb+rPI1TdUADQI="
      }, {
        "num_cand": "U2FsdGVkX1+wP/+xPxY4+se0LmQ0Y3fxJTPJ5J6fEew=",
        "cpf": "U2FsdGVkX184YpM0ChZ2GsTFP4EMTxFIRzGrJqG69E4="
      }, {
        "num_cand": "U2FsdGVkX186uTYShWOj7HdTO0PpvG98WGIJICoR9GU=",
        "cpf": "U2FsdGVkX19tQCZ5pUlOEJwSx0g1Iyro2r+2G+S7e48="
      }, {
        "num_cand": "U2FsdGVkX18ve00LaTyJv4XKC2qMW1BKW/UlOBKbj9o=",
        "cpf": "U2FsdGVkX1/JfCReTdTGflrlLNq5gdh3uPVQeDKX/S0="
      }, {
        "num_cand": "U2FsdGVkX1/P0MNDegh2A01SQkFWif4+rEEBroc+PoU=",
        "cpf": "U2FsdGVkX1/cdypeDiEO/OxBXzFHNiXDzzvSOf2PV0Y="
      }, {
        "num_cand": "U2FsdGVkX19boSzNGnGkJRKtqSr1g7HP4srr134OCPs=",
        "cpf": "U2FsdGVkX1+IntHoUe0GZIXrf8Q+W9p/0G3mZZ0Ku0c="
      }, {
        "num_cand": "U2FsdGVkX1/d3Z2/u1kH2qesG4M2rN9nDa449O9PID4=",
        "cpf": "U2FsdGVkX1++/kLZGWmlns6qWWFHEL4cCsYYfywvi4c="
      }, {
        "num_cand": "U2FsdGVkX188LlddVMcKGXpSx6lrSYXKYEHrotUH0wM=",
        "cpf": "U2FsdGVkX1/FaP1MpdUkqULBrmYs9+Ze1Z95T6YHJXE="
      }, {
        "num_cand": "U2FsdGVkX1+nUvUCAdv0Ja3BP5Mm9aF/tPq/aWsoEjs=",
        "cpf": "U2FsdGVkX19ohw8qe0Z8yaOXD8Bo3sNfjrmIP00A+cY="
      }, {
        "num_cand": "U2FsdGVkX18AflQz6mny0I0yQnKflLeuxP+KjNJvJRU=",
        "cpf": "U2FsdGVkX1/SKKwMSmwao5pbCxZNM6bp3jO25R/hIU0="
      }, {
        "num_cand": "U2FsdGVkX1+opekt3G0f7xexgiqOzMIX0IL244EyTZg=",
        "cpf": "U2FsdGVkX1/aDZo8RrLJ4kA5rUis7yesp1Sr703giVo="
      }, {
        "num_cand": "U2FsdGVkX181xCj2oAFAgnJbI2N0pNKhwzTnBvUaE2o=",
        "cpf": "U2FsdGVkX1/HoAQLnAj35MEl7vflpfrpcG9ON8Hnqtc="
      }, {
        "num_cand": "U2FsdGVkX1/xV32+4BiVde0vJBaMIVZbGOKWHlLg2tg=",
        "cpf": "U2FsdGVkX1+jLbBsLBzlfaXar7QpIF355O16TY5a0Vc="
      }, {
        "num_cand": "U2FsdGVkX1+ajvydpXgWZyKYD0tR/E2fu05V2OdZFB0=",
        "cpf": "U2FsdGVkX1+wHxYYwOTxUSMGfZ4X0paen64sHYIRhI4="
      }, {
        "num_cand": "U2FsdGVkX1+fqYGHO07uKCqZHIznsf+v/z20goiIYs4=",
        "cpf": "U2FsdGVkX1/Hnt6K97uaGmPET8qLcJ73zrUeXhotvDs="
      }, {
        "num_cand": "U2FsdGVkX1++AAHFIQAPErR9e7U4PFCmnGynhCWCCm0=",
        "cpf": "U2FsdGVkX18aUNWg/hWctaRZXsC8G7p5Qry2VzBzXDU="
      }, {
        "num_cand": "U2FsdGVkX18R+QmvCkQbzQBcvAzp9GRB+RL7yF8dCqM=",
        "cpf": "U2FsdGVkX1984TjwMz2G+zwwZPRy4mzzy0456fDbiJ0="
      }, {
        "num_cand": "U2FsdGVkX1+KyuAfSZ7uIVoNxENpPFGqKg6M4we9+0o=",
        "cpf": "U2FsdGVkX18urPOFRDM+APAbngYNuf1UeUNjOSiPfdg="
      }, {
        "num_cand": "U2FsdGVkX19qNfL0qeq0y10whxKL1iF/0xiqKg/2jGY=",
        "cpf": "U2FsdGVkX1/XhshhLRa0ZBp9fJ1ygeTKXAThBX0eXsg="
      }, {
        "num_cand": "U2FsdGVkX19V0DUMyZy72wwiPfPWJoQORbF+yYsKIps=",
        "cpf": "U2FsdGVkX19Z98QAqnV2XfTWoP5ERGTjVGd8s4pHv+g="
      }, {
        "num_cand": "U2FsdGVkX18U3UITGUtBiof0nVGCgv2+alAkEg7KLIk=",
        "cpf": "U2FsdGVkX19AXEbMoQSm6LimJenrIt0V308ChYnuzvE="
      }, {
        "num_cand": "U2FsdGVkX1+MrneLZx8AvrBOfk99qa1XCVgkDbeosJY=",
        "cpf": "U2FsdGVkX19gWv85d8hieKUXRogTo6y2e8X+FNN/bsU="
      }, {
        "num_cand": "U2FsdGVkX19tBeoA5UcSGsxCOteipX0sRM6O+yQDUas=",
        "cpf": "U2FsdGVkX1+rVaXk+pMc+00BMpPIzNo1w1XYNbzRRQo="
      }, {
        "num_cand": "U2FsdGVkX19wXg5BojjfUrQWwqvWp5Fx9c8mg6S15ko=",
        "cpf": "U2FsdGVkX19pjgPoKg6EraOuTD5mYMnJJGK8ZAJ+JeM="
      }, {
        "num_cand": "U2FsdGVkX1/rN5iHniqDnnaPKV9J2BuBZZfAthoUH9E=",
        "cpf": "U2FsdGVkX1/O/8vyZJ258li+QwWRQ4af7w8JbR9KTYQ="
      }, {
        "num_cand": "U2FsdGVkX18RTVNVkyZMZmLv9dSCxfNldi/td/unoSY=",
        "cpf": "U2FsdGVkX1+itwj27AG6170PxMkHtHkKJ6RdCrzLXE8="
      }, {
        "num_cand": "U2FsdGVkX190W6ORb2cuyfpFr1A7VB6jwAMXj4YY4XY=",
        "cpf": "U2FsdGVkX1+67Ln+Ao/RfjtuMhD60c1qWhxao4czfMA="
      }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2207/2007_result_impu/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
